import React from "react";
import styled from "styled-components";
import { Stack } from "react-bootstrap";
import { useMemo } from "react";
import { PagoVenta } from "../../services/ventasServicios";
import { dateCompareStr } from "../../utils/dateUtils";
import TableTitle from "../organisms/TableTitle";
import PagosTable from "./PagosTable";

function PagosTableSection({ pagos }: { pagos: PagoVenta[] }) {
  const items = useMemo(() => {
    let abonosOrdenados = pagos;
    abonosOrdenados.sort((itemA, itemB) => {
      return dateCompareStr(itemA.fecha, itemB.fecha);
    });
    return abonosOrdenados;
  }, [pagos]);

  if (pagos.length === 0) {
    return <></>;
  }

  return (
    <ResponsiveTableSection>
      <TableTitle>{"Pagos"}</TableTitle>
      <TableWrapper>
        <Stack gap={4}>
          <PagosTable items={items} />
        </Stack>
      </TableWrapper>
    </ResponsiveTableSection>
  );
}

const ResponsiveTableSection = styled("div")`
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

const TableWrapper = styled("div")`
  position: relative;
  clear: both;
  zoom: 1;
`;

export default PagosTableSection;
